// Utils
import { appendOpacityValueToColour } from '../../../utils/colours';
import { dash, contact, patient, clinical, financial, report, admin, help, boarding, documents, oxfordBlue, seafoam, } from '../../colours';
import { green, red, yellow, primary, neutrals } from '../../colours/spotPrimitives';
import { systemFonts } from '../../typography';
// This is based on IDEXX's Spot V2 colours
export var spotTheme = {
    typography: {
        fontFamily: systemFonts,
    },
    /**
     * Ezyvet component styles
     */
    disabledGradient: {
        100: neutrals[25],
        200: neutrals[50],
        300: neutrals[100],
        400: neutrals[200],
        500: neutrals[300],
    },
    /**
     * Backgrounds & borders
     */
    backgroundUI: neutrals['0'],
    backgroundPrimary: neutrals['50'],
    backgroundSecondary: neutrals['25'],
    backgroundTertiary: neutrals['100'],
    backgroundPositive: green['100'],
    backgroundWarning: yellow['100'],
    backgroundNegative: red['700'],
    backgroundAccentPrimary: primary['600'],
    backgroundAccentSecondary: primary['50'],
    backgroundAccentTertiary: primary['100'],
    backgroundPositivePrimary: green['50'],
    backgroundPositiveSecondary: green['100'],
    backgroundWarningPrimary: yellow['50'],
    backgroundWarningSecondary: yellow['300'],
    backgroundNegativePrimary: red['50'],
    backgroundNegativeSecondary: red['100'],
    backgroundTransparent: 'transparent',
    backgroundOverlay: appendOpacityValueToColour(neutrals['900'], 10),
    borderPrimary: neutrals['200'],
    borderSecondary: neutrals['300'],
    borderTertiary: neutrals['800'],
    borderAccent: primary['600'],
    borderNegative: red['500'],
    /**
     * Content
     */
    contentPrimary: neutrals['800'],
    contentSecondary: neutrals['750'],
    contentTertiary: neutrals['700'],
    contentAccessory: neutrals['650'],
    contentOnColor: neutrals['0'],
    contentAccent: primary['600'],
    contentAccentOnColor: primary['800'],
    contentPositive: green['500'],
    contentPositiveOnColor: green['900'],
    contentWarning: yellow['500'],
    contentWarningOnColor: yellow['900'],
    contentNegative: red['500'],
    contentNegativeOnColor: red['900'],
    /**
     * Interactive
     */
    hoverAccent: primary['700'],
    hoverHighlight: primary['50'],
    clickedAccent: primary['800'],
    clickedHighlight: primary['100'],
    hoverOverlayPrimary: appendOpacityValueToColour(neutrals['900'], 5),
    hoverOverlaySecondary: appendOpacityValueToColour(neutrals['900'], 10),
    hoverOverlayWhite: appendOpacityValueToColour(neutrals['0'], 5),
    clickedOverlay: appendOpacityValueToColour(neutrals['900'], 15),
    clickedOverlayWhite: appendOpacityValueToColour(neutrals['0'], 15),
    disabledPrimary: neutrals['100'],
    disabledSecondary: neutrals['300'],
    disabledTertiary: neutrals['700'],
    disabledAccent: neutrals['200'],
    /**
     * Records
     */
    recordsDashboard: dash['600'],
    recordsDashboardPrimary: dash['50'],
    recordsDashboardSecondary: dash['100'],
    recordsDashboardTertiary: dash['200'],
    recordsContact: contact['400'],
    recordsContactPrimary: contact['50'],
    recordsContactSecondary: contact['100'],
    recordsContactTertiary: contact['200'],
    recordsPatient: patient['300'],
    recordsPatientPrimary: patient['50'],
    recordsPatientSecondary: patient['100'],
    recordsPatientTertiary: patient['200'],
    recordsClinical: clinical['500'],
    recordsClinicalPrimary: clinical['50'],
    recordsClinicalSecondary: clinical['100'],
    recordsClinicalTertiary: clinical['200'],
    recordsFinancial: financial['700'],
    recordsFinancialPrimary: financial['50'],
    recordsFinancialSecondary: financial['100'],
    recordsFinancialTertiary: financial['200'],
    recordsReport: report['300'],
    recordsReportPrimary: report['50'],
    recordsReportSecondary: report['100'],
    recordsReportTertiary: report['200'],
    recordsAdmin: admin['300'],
    recordsAdminPrimary: admin['50'],
    recordsAdminSecondary: admin['100'],
    recordsAdminTertiary: admin['200'],
    recordsHelp: help['500'],
    recordsHelpPrimary: help['50'],
    recordsHelpSecondary: help['100'],
    recordsHelpTertiary: help['200'],
    recordsBoarding: boarding['400'],
    recordsBoardingPrimary: boarding['50'],
    recordsBoardingSecondary: boarding['100'],
    recordsBoardingTertiary: boarding['200'],
    recordsDocuments: documents['400'],
    recordsDocumentsPrimary: documents['50'],
    recordsDocumentsSecondary: documents['100'],
    recordsDocumentsTertiary: documents['200'],
    /**
     * Branding
     */
    brandingPrimary1: oxfordBlue['100'],
    brandingPrimary2: oxfordBlue['80'],
    brandingPrimary3: oxfordBlue['60'],
    brandingPrimary4: oxfordBlue['40'],
    brandingPrimary5: oxfordBlue['20'],
    brandingSecondary1: seafoam['100'],
    brandingSecondary2: seafoam['80'],
    brandingSecondary3: seafoam['60'],
    brandingSecondary4: seafoam['40'],
    brandingSecondary5: seafoam['20'],
};
//# sourceMappingURL=spotTheme.js.map